angular.module('graph').controller('ph-comment-ctrl', [
    '$scope',
    'ph-core',
    'ph-paging',
    'ph-broadcast',
    'ph-touch-service',
    '$timeout',
    '$rootScope',
    function ($scope,
              $core,
              $paging,
              $broadcast,
              $phtouch,
              $timeout,
              $root
    ) {
        $scope.touched = 0;
        $scope.$paging = $paging.new();
        $scope.$comments = [];
        $scope.$entry = null;
        $scope.$entry_id = 0;
        $scope.$listen = null;

        $scope.$entry = function ($name, $id) {
            $scope.$entry = $name;
            $scope.$entry_id = $id;
            $scope.$paging = $paging.new();
            $scope.$listen = 'ph-comment:' + $name + ':' + $id;

            $phtouch.$watch($scope, $scope.$listen, function () {
                $phtouch.$touch($scope.$listen, function () {
                    $scope.touched = 1;

                    $scope.find();
                });
            });

            /**
             *
             */
            $broadcast.on($name + ':comments:publish', function ($data, $guid) {
                if ($core.$guid !== $guid && $scope.touched > 0) {
                    ++$scope.$paging.let;
                    $scope.$comments.unshift($data.meta);

                    /**
                     *
                     */
                    $broadcast.emit('join:comment', [$data.meta.id]);
                }
            });
        };

        function make(state) {
            if (state === 'entry') {
                var $entry = $scope.$entry !== null ? $scope.$entry + '/' : '';
                $entry += $scope.$entry_id !== 0 ? $scope.$entry_id + '/' : '';

                return $entry;
            }

        }

        var lock = false;

        $scope.publish = function () {
            if (lock === false) {
                lock = true;
                $core.$with.lock(function ($unlock) {
                    $timeout(function () {
                        $core.post('/xhr/' + make('entry') + 'comments', $scope.$comment).then(function ($response) {
                            if ($response.data.state === 0) {
                                $scope.$comments.unshift($response.data.data);

                                /**
                                 *
                                 */
                                $broadcast.emit('join:comment', [$response.data.data.id]);

                                $scope.$comment.content = '';

                            } else {
                                $root.$broadcast('ph-modal-show', $response.data.data.content);
                            }
                            $unlock();
                            lock = false;
                        });
                    }, 200);
                });
            }
        };

        $scope.keyboard = function ($event) {
            if ($event.which === 13) {
                if ($event.shiftKey) {
                    // make enter
                } else {
                    $event.preventDefault();
                    $scope.publish();
                }
            }
        };

        $scope.find = function () {
            $core.get('/xhr/' + make('entry') + 'comments?page=' + +(++$scope.$paging.page) + '&let=' + $scope.$paging.let)
                .then(function ($response) {
                    var connect = [];

                    /**
                     *
                     */
                    for (var i = 0; i < $response.data.data.length; i++) {
                        connect.push($response.data.data[i].id);
                    }

                    /**
                     *
                     */
                    $broadcast.emit('join:comment', connect);

                    /**
                     *
                     */
                    $scope.$comments = $scope.$comments.concat(
                        $response.data.data
                    );
                });
        };

        $scope.$like = function ($$comment) {
            $core.post('/xhr/comment/' + $$comment.id + '/likes')
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        ++$$comment.likes;
                        $$comment.liked = true;
                    }
                });
        };

        $scope.$unlike = function ($$comment) {
            $core.delete('/xhr/comment/' + $$comment.id + '/likes')
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        --$$comment.likes;
                        $$comment.liked = false;
                    }
                });
        };

        /**
         *
         */
        $broadcast.on('comment:likes:like', function ($data, $guid) {
            if ($core.$guid !== $guid) {
                $core.$array.find($scope.$comments, $data['entry'].id, function (post, key) {
                    ++$scope.$comments[key].likes;
                    $scope.$digest();
                }, function () {
                    // console.log('not found');
                });
            }
        });

        /**
         *
         */
        $broadcast.on('comment:likes:unlike', function ($data, $guid) {
            if ($core.$guid !== $guid) {
                $core.$array.find($scope.$comments, $data['entry'].id, function (post, key) {
                    --$scope.$comments[key].likes;
                    $scope.$digest();
                }, function () {
                    // console.log('not found');
                });
            }
        });

        /**
         *
         */
        $broadcast.on('me:comment:likes:like', function ($data, $guid) {
            if ($core.$guid !== $guid) {
                $core.$array.find($scope.$comments, $data['entry'].id, function (post, key) {
                    $scope.$comments[key].liked = true;
                    $scope.$digest();
                }, function () {
                    // console.log('not found');
                });
            }
        });

        /**
         *
         */
        $broadcast.on('me:comment:likes:unlike', function ($data, $guid) {
            if ($core.$guid !== $guid) {
                $core.$array.find($scope.$comments, $data['entry'].id, function (post, key) {
                    $scope.$comments[key].liked = false;
                    $scope.$digest();
                }, function () {
                    // console.log('not found');
                });
            }
        });
    }
]);
